<ng-container *appTranslate="let t">
  <p-floatlabel variant="in">
    <p-select
      [(ngModel)]="preferredCommunicationLanguage"
      [options]="availableLanguages$ | async"
      dataKey="code"
      [fluid]="true"
      (onClick)="onClick($event)"
      (onChange)="setCommunicationLanguage()"
    >
      <ng-template #item #selectedItem let-item>
        <div class="row">
          <new-ui-flag [country]="item.flag" [small]="true" />
          <span>{{ item.label }}</span>
        </div>
      </ng-template>
    </p-select>

    <label>
      {{ t("userLanguage.title") }}
      <i
        class="ml-1 pi pi-info-circle"
        style="pointer-events: auto; font-size: inherit"
        [pTooltip]="t('userLanguage.tooltip')"
      ></i>
    </label>
  </p-floatlabel>
</ng-container>
